import { IconButton, Pill } from "@smartsuite/react-ui/lib";
import { observer } from "mobx-react-lite";
import * as S from "../style";
import type {
  ValueConfig,
  ValueConfig_V,
} from "@smartsuite/automation-engine-api";
import { translateIfPresent } from "../../../../../../../../../locales/i18n";
import { useReferenceHook } from "../utils/reference.hook";
import { Colors } from "@smartsuite/types";
import { useEffect, useState } from "react";
import type { PillNodeAttrs } from "@smartsuite/smartdoc";
import { getIcon } from "../utils/render-options";
import { Space } from "../style";
import type { ActionCandidate } from "../../../../../../../../../types/candidate";

export const ReferenceValue = observer<{
  config?: ValueConfig;
  value: ValueConfig_V;
  onRemove?: (index: number) => void;
  onEdit?: (index: number) => void;
  index?: number;
  label?: string;
  action?: ActionCandidate;
}>(({ value, onRemove, onEdit, index, config, label, action }) => {
  const { pills, getOutputRef } = useReferenceHook(config, action);
  const [ref, setRef] = useState<PillNodeAttrs | undefined>();
  const [isNoError, setIsNoError] = useState<boolean>(true);

  useEffect(() => {
    if (value.value.oneofKind !== "reference") {
      return;
    }

    const ref = getOutputRef(value.value.reference);
    const isNoError =
      ref !== undefined &&
      // @ts-expect-error - isError expected to be a boolean
      !ref?.isError &&
      !JSON.parse(ref.value ?? "{}")?.isError;

    setRef(ref);
    setIsNoError(isNoError);
  }, [pills]);

  if (value.value.oneofKind !== "reference") {
    return null;
  }

  return (
    <S.Root>
      <span>
        {getIcon(ref?.icon ?? "")}
        <S.Text marginRight={"5px"}>{label}: </S.Text>
        <Pill
          text={translateIfPresent(
            `caption.${ref?.title ?? value.value.reference.outputId}`,
            ref?.title ?? value.value.reference.outputId,
          )}
          styles={{
            backgroundDefault: isNoError ? Colors.dwBlue : Colors.wPink,
          }}
        />
      </span>
      <S.StyledRemoveButton>
        <IconButton
          name="edit-thin"
          size="S"
          ariaLabel="Edit Button"
          color="currentColor"
          hoverColor="currentColor"
          onClick={() => index !== undefined && onEdit && onEdit(index)}
        />
        <Space />
        <IconButton
          name="trash-thin"
          size="S"
          ariaLabel="Remove Button"
          color="currentColor"
          hoverColor="currentColor"
          onClick={() => index !== undefined && onRemove && onRemove(index)}
        />
      </S.StyledRemoveButton>
    </S.Root>
  );
});
